var generateOrderId = function generateOrderId() {
  return new Date().getUTCMilliseconds() + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

export default generateOrderId;